import { render } from "./RunHistory.vue?vue&type=template&id=6348d874&scoped=true"
import script from "./RunHistory.vue?vue&type=script&lang=js"
export * from "./RunHistory.vue?vue&type=script&lang=js"

import "./RunHistory.vue?vue&type=style&index=0&id=6348d874&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6348d874"]])

export default __exports__